import { api } from '..'

export const deleteAlertRule = (alertRuleId: string) => () =>
  api.delete(`/v1/alert-rules/${alertRuleId}`)
